<template>
  <div class="modal inmodal in" tabindex="-1" :style="display">
    <div class="modal-dialog">
      <div class="modal-content animated fadeIn">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            @click="closeModal"
          >
            <span aria-hidden="true">&times;</span>
            <span class="sr-only">
              Close
            </span>
          </button>
          <i class="fa fa-unlock modal-icon"></i>
          <h4 class="modal-title">Exportação dos Registors</h4>
          <small></small>
        </div>

        <div class="modal-body">
          <p>
            Deseja confirmar a exportação de <strong>{{ totalDocuments }}</strong> registros em arquivo?
          </p>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-white"
            data-dismiss="modal"
            @click="closeModal"
          >
            Cancelar
          </button>

          <button
            type="button"
            class="btn btn-success"
            @click="confirmAction"
          >
            Confirmar Exportação
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    totalDocuments: {
      default: false,
    },
    show: {
      default: false,
    },
  },
  computed: {
    display() {
      return this.show ? 'display: block' : 'display: none';
    },
  },
  methods: {
    closeModal() {
      this.$emit('close-modal');
    },
    async confirmAction() {
      this.$emit('confirm');
    },
  },
};
</script>
